/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import { API_URL } from "../config";

// ── Kayar Bant Bileşeni ───────────────────────────────────────
/*function KayarBant({ icerik, renk = "#1e3a5f", bg = "#f0f7ff", hiz = 40 }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        let pos = 0;
        const toplam = el.scrollWidth / 2;
        const adim = () => {
            pos += hiz / 60;
            if (pos >= toplam) pos = 0;
            el.style.transform = `translateX(-${pos}px)`;
        };
        const id = setInterval(adim, 1000 / 60);
        return () => clearInterval(id);
    }, [icerik, hiz]);

    if (!icerik?.length) return null;

    const dupIcerik = [...icerik, ...icerik]; // sonsuz döngü için çift

    return (
        <div style={{ overflow: "hidden", background: bg, borderBottom: `1px solid #e5e7eb`, height: "36px", display: "flex", alignItems: "center" }}>
            <div ref={ref} style={{ display: "flex", whiteSpace: "nowrap", willChange: "transform" }}>
                {dupIcerik.map((item, i) => (
                    <span key={i} style={{
                        padding: "0 24px", fontSize: "13px", fontWeight: "600",
                        color: item.renk || renk, borderRight: "1px solid #e5e7eb",
                        display: "inline-flex", alignItems: "center", gap: "6px"
                    }}>
                        {item.ikon && <span>{item.ikon}</span>}
                        <span style={{ color: "#6b7280", fontWeight: "500" }}>{item.ad}:</span>
                        {item.deger}
                        {item.degisim != null && (
                            <span style={{ fontSize: "11px", color: item.degisim >= 0 ? "#16a34a" : "#dc2626" }}>
                                {item.degisim >= 0 ? "▲" : "▼"}{Math.abs(item.degisim).toFixed(2)}%
                            </span>
                        )}
                    </span>
                ))}
            </div>
        </div>
    );
}*/

// ── Haber Bandı Bileşeni ──────────────────────────────────────
function HaberBant({ baslik, haberler, bg = "#fff8f0", hiz = 35 }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        let pos = 0;
        const toplam = el.scrollWidth / 2;
        const adim = () => {
            pos += hiz / 60;
            if (pos >= toplam) pos = 0;
            el.style.transform = `translateX(-${pos}px)`;
        };
        const id = setInterval(adim, 1000 / 60);
        return () => clearInterval(id);
    }, [haberler, hiz]);

	if (!haberler?.length) return (
		<div style={{ overflow: "hidden", background: bg, borderBottom: "1px solid #e5e7eb",
			height: "36px", display: "flex", alignItems: "center" }}>
			<div style={{ flexShrink: 0, padding: "0 12px", fontWeight: "700", fontSize: "11px",
				color: "white", background: baslik === "SON DAKİKA" ? "#dc2626" : "#d97706",
				height: "100%", display: "flex", alignItems: "center" }}>{baslik}</div>
			<span style={{ padding: "0 16px", fontSize: "12px", color: "#9ca3af" }}>Haberler yükleniyor...</span>
		</div>
	);

    const dupHaberler = [...haberler, ...haberler];

    return (
        <div style={{ overflow: "hidden", background: bg, borderBottom: "1px solid #e5e7eb", height: "36px", display: "flex", alignItems: "center" }}>
            {/* Başlık etiketi */}
            <div style={{ flexShrink: 0, padding: "0 12px", fontWeight: "700", fontSize: "11px",
                color: "white", background: baslik === "SON DAKİKA" ? "#dc2626" : "#d97706",
                height: "100%", display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                {baslik}
            </div>
            {/* Kayan içerik */}
            <div style={{ overflow: "hidden", flex: 1, height: "100%", display: "flex", alignItems: "center" }}>
                <div ref={ref} style={{ display: "flex", whiteSpace: "nowrap", willChange: "transform" }}>
                    {dupHaberler.map((h, i) => (
                        <span key={i} style={{ padding: "0 20px", fontSize: "12px", color: "#374151",
                            borderRight: "1px solid #e5e7eb", display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            <span style={{ color: "#9ca3af" }}>■</span>
                            {h.link
                                ? <a href={h.link} target="_blank" rel="noreferrer"
                                    style={{ color: "#374151", textDecoration: "none" }}>{h.baslik}</a>
                                : h.baslik}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}

// ── TradingView Widget ────────────────────────────────────────
function TradingViewWidget({ sembol: baslangicSembol = "BIST:XU100" }) {
    const [sembol, setSembol] = useState(baslangicSembol);
    const [input,  setInput]  = useState(baslangicSembol);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;
        container.innerHTML = "";

        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = JSON.stringify({
            autosize:          true,
            symbol:            sembol,
            interval:          "D",
            timezone:          "Europe/Istanbul",
            theme:             "light",
            style:             "1",
            locale:            "tr",
            enable_publishing: false,
            allow_symbol_change: false,
            save_image:        false,
            calendar:          false,
            hide_top_toolbar:  false,
        });
        container.appendChild(script);
    }, [sembol]);

    return (
        <div style={{ padding: "1rem", background: "#f8fafc" }}>
            {/* Sembol değiştirme */}
            <div style={{ display: "flex", gap: "8px", marginBottom: "12px", alignItems: "center" }}>
                <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: "500" }}>Sembol:</span>
                <input
                    value={input}
                    onChange={e => setInput(e.target.value.toUpperCase())}
                    onKeyDown={e => e.key === "Enter" && setSembol(input)}
                    style={{ padding: "4px 10px", borderRadius: "6px", border: "1px solid #d1d5db",
                        fontSize: "13px", width: "180px", fontWeight: "600" }}
                    placeholder="Örn: BIST:XU100"
                />
                <button onClick={() => setSembol(input)}
                    style={{ padding: "4px 14px", background: "#1e3a5f", color: "white",
                        border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "13px" }}>
                    Uygula
                </button>
                {["THYAO", "BINANCE:BTCUSDT", "BINANCE:ETHUSDT", "FOREXCOM:USDTRY"].map(s => (
                    <button key={s} onClick={() => { setSembol(s); setInput(s); }}
                        style={{ padding: "4px 10px", background: sembol === s ? "#2563eb" : "#e5e7eb",
                            color: sembol === s ? "white" : "#374151", border: "none",
                            borderRadius: "6px", cursor: "pointer", fontSize: "11px", fontWeight: "600" }}>
                        {s.split(":")[1] || s}
                    </button>
                ))}
            </div>
            {/* TradingView kapsayıcı */}
            <div style={{ height: "500px", border: "1px solid #e5e7eb", borderRadius: "8px", overflow: "hidden" }}>
                <div className="tradingview-widget-container" ref={containerRef} style={{ height: "100%", width: "100%" }}>
                    <div className="tradingview-widget-container__widget" style={{ height: "100%", width: "100%" }} />
                </div>
            </div>
        </div>
    );
}

// ── Ana Sayfa ─────────────────────────────────────────────────
export default function AnaSayfa() {
    const [finansal,    setFinansal]    = useState([]);
    const [guncelHaber, setGuncelHaber] = useState([]);
    const [sonDakika,   setSonDakika]   = useState([]);

    const getToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.access_token;
    };

    const finansalYukle = async () => {
        try {
            const token = await getToken();
            const res   = await axios.get(`${API_URL}/scan/finansal-veri`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data  = res.data;
            const MAP   = [
                { ad: "BIST100",  key: "BIST100",  ikon: "📊", format: v => v.toLocaleString("tr-TR", { maximumFractionDigits: 0 }) },
                { ad: "Dolar",    key: "Dolar",     ikon: "💵", format: v => v.toFixed(2) + " ₺" },
                { ad: "Euro",     key: "Euro",      ikon: "💶", format: v => v.toFixed(2) + " ₺" },
                { ad: "Altın",    key: "Altin",     ikon: "🥇", format: v => "$" + v.toLocaleString("en-US", { maximumFractionDigits: 1 }) },
                { ad: "Gümüş",   key: "Gumus",     ikon: "🥈", format: v => "$" + v.toFixed(2) },
                { ad: "Bitcoin", key: "Bitcoin",   ikon: "₿",  format: v => "$" + v.toLocaleString("en-US", { maximumFractionDigits: 0 }) },
                { ad: "ETH",     key: "Ethereum",  ikon: "🔷", format: v => "$" + v.toLocaleString("en-US", { maximumFractionDigits: 0 }) },
            ];
            setFinansal(MAP.filter(m => data[m.key] != null).map(m => ({
                ad: m.ad, ikon: m.ikon, deger: m.format(data[m.key]),
            })));
        } catch {}
    };

    const haberYukle = async (kategori, setter) => {
        try {
            const token = await getToken();
            const res   = await axios.get(`${API_URL}/scan/haberler/${kategori}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setter(res.data.haberler || []);
        } catch {}
    };

    useEffect(() => {
        finansalYukle();
        haberYukle("guncel",     setGuncelHaber);
        haberYukle("son_dakika", setSonDakika);

        // 60 saniyede bir finansal veri yenile
        const id1 = setInterval(finansalYukle, 60000);
        // 5 dakikada bir haber yenile
        const id2 = setInterval(() => haberYukle("guncel",     setGuncelHaber), 300000);
        const id3 = setInterval(() => haberYukle("son_dakika", setSonDakika),   300000);
        return () => { clearInterval(id1); clearInterval(id2); clearInterval(id3); };
    }, []);

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {/* Finansal veri bandı */}
			<HaberBant
				baslik="FİNANSAL VERİLER"
				haberler={finansal.map(f => ({ baslik: `${f.ikon} ${f.ad}: ${f.deger}` }))}
				bg="#f0f7ff"
				hiz={40}
			/> 

            {/* Güncel haberler */}
            <HaberBant baslik="GÜNCEL" haberler={guncelHaber} bg="#fffbeb" hiz={32} />

            {/* Son dakika */}
            <HaberBant baslik="SON DAKİKA" haberler={sonDakika} bg="#fff1f2" hiz={36} />

            {/* TradingView */}
            <div style={{ flex: 1, overflow: "auto" }}>
                <TradingViewWidget sembol="THYAO" />
            </div>
        </div>
    );
}
